import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Button } from './Button';
interface ActionRowProps {
  onBack?: () => void;
  backLabel?: string;
  children?: React.ReactNode;
}
export function ActionRow({
  onBack,
  backLabel = 'Back',
  children
}: ActionRowProps) {
  return <div className="mt-8 flex flex-col-reverse gap-3 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-493" data-mp="260qnkdbi5kcf">
      {onBack ? <Button variant="secondary" onClick={onBack} icon={<ArrowLeftIcon size={18} aria-hidden="true" data-id="element-495" data-mp="1wb76nd7co0k7" />} data-id="element-494" data-mp="212grm0hyefpr">
          {backLabel}
        </Button> : <span data-id="element-496" data-mp="1s93qib9qk7sl" />}
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-end" data-id="element-497" data-mp="1saex0iukftne">{children}</div>
    </div>;
}